import {mutations} from './mutations';
import {actions} from './actions';
import {getters} from './getters';

const state = {

    entryLinks: [],
    loading: false,
    saving: false,
    expired: null,
};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
}

